import { render } from "./MangelItemTemplate.vue?vue&type=template&id=1028a043&ts=true"
import script from "./MangelItemTemplate.vue?vue&type=script&lang=ts"
export * from "./MangelItemTemplate.vue?vue&type=script&lang=ts"

import "./MangelItemTemplate.vue?vue&type=style&index=0&id=1028a043&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__